export default __webpack_public_path__ + "static/media/gf-bot-link.d6b47d7a.png";